import * as React from 'react'
import { useState } from 'react'

import { Box, Icon, Tooltip, colors, useToggle } from '@factorialco/deprecated-design-system'
import { Picker } from 'emoji-mart/dist-es/index.js'

import { observer } from 'mobx-react'

import Popover from 'modules/core/components/Popover'
import i18n from 'modules/core/lib/i18n'

import './emoji-mart.module.scss'
import { translations } from './translations'

interface EmojiType {
  id?: string
}

type PickerProps = React.ComponentProps<typeof Picker>

interface Props {
  onEmojiSelected: (emojiId: string) => void
  onToggle?: (value: boolean) => void
}

const EmojiPicker = ({ onEmojiSelected, onToggle }: Props) => {
  const [open, toggle] = useToggle(false)
  const [hover, setHover] = useState(false)

  const handleClick = async (emojiId: string) => {
    await onEmojiSelected(emojiId)
  }

  const onPickEmoji: PickerProps['onClick'] = (
    emoji: EmojiType,
    event: React.BaseSyntheticEvent
  ) => {
    event.preventDefault()
    event.stopPropagation()

    toggle(false)()

    if (emoji.id) {
      handleClick(emoji.id)
    }
  }

  return (
    <Popover
      attachment="bottom center"
      open={open}
      toggle={(value: boolean) => {
        onToggle && onToggle(value)

        return toggle(!open)
      }}
      size="big"
    >
      <Box
        border={{ all: { width: 's1', style: 'solid', color: 'grey700' } }}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        alignItems="center"
        justifyContent="center"
        height="s32"
        width="s32"
        borderRadius={{ all: 'abs008' }}
      >
        <Tooltip.Alt
          attachment="bottom center"
          open={hover && !open}
          label={i18n.t('reactions.new')}
        >
          <Icon.Medium icon="reaction" color="grey700" />
        </Tooltip.Alt>
      </Box>

      <Picker
        emojiSize={16}
        sheetSize={32}
        exclude={['custom']}
        title=""
        color={colors.viridian1000}
        emoji="+1"
        onClick={onPickEmoji}
        i18n={translations()}
      />
    </Popover>
  )
}

export default observer(EmojiPicker)
